import { render, staticRenderFns } from "./issue-codes-table.vue?vue&type=template&id=75c1c0bc&scoped=true&"
import script from "./issue-codes-table.vue?vue&type=script&lang=js&"
export * from "./issue-codes-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c1c0bc",
  null
  
)

export default component.exports